<template>
    <div>
        <a-row>
            <a-col :span="24" style="margin-bottom: 10px;border-bottom: 1px solid #f0f2f5;">
                <a-row type="flex" justify="end">
                    <a-col :span="20" :style="{textAlign: 'left',padding: '10px 0 0 20px'}">
                        <span style="font-size: 1.6em;">产品列表</span>
                    </a-col>
                    <a-col :span="4" :style="{textAlign: 'right', padding: '10px 20px 10px 0'}">
                        <a-button type="primary" @click="editInfo('add')">
                            添加产品
                        </a-button>
                    </a-col>
                </a-row>
            </a-col>
            <a-col :span="24" :style="{padding: '10px 24px 10px 24px'}">
                <a-row>
                    <a-col :span="6" :offset="12" style="padding-left: 10px;">
                        <a-select
                            mode="multiple"
                            :default-value="[]"
                            style="width: 100%"
                            placeholder="请选择网站"
                            @change="handleSelectWebsiteChange"
                        >
                            <a-select-option v-for="i in website" :key="i.uuid">
                                {{ i.title }}
                            </a-select-option>
                        </a-select>
                    </a-col>
                    <a-col :span="6" style="padding-left: 10px;">
                        <a-select
                            mode="multiple"
                            :default-value="[]"
                            style="width: 100%"
                            placeholder="请选择产品分类"
                            @change="handleSelectCategoryChange"
                        >
                            <a-select-option v-for="i in category" :key="i.uuid">
                                {{ i.title }}
                            </a-select-option>
                        </a-select>
                    </a-col>
                </a-row>
            </a-col>
            <a-col :span="24" :style="{padding: '2px 24px 24px 24px'}">
                <a-table
                    :columns="columns"
                    :row-key="record => record.productDO.uuid"
                    :data-source="data"
                    :pagination="pagination"
                    :loading="loading"
                    @change="handleTableChange"
                    bordered
                >
                    <span slot="action" slot-scope="record">

                        <a href="javascript:;" @click="editContent(record.productDO.uuid)" style="margin-left: 5px;">更新详情</a>
                        <a href="javascript:;" @click="editInfo(record.productDO.uuid)" style="margin-left: 5px;">编辑</a>

                        <a-popconfirm
                            v-if="data.length"
                            title="确定删除该产品吗?"
                            @confirm="() => deleteProduct(record.productDO.uuid)"
                            ok-text="删除"
                            cancel-text="取消"
                            style="margin-left: 5px;"
                        >
                            <a-button size="small" type="danger">
                                删除
                            </a-button>
                        </a-popconfirm>
                    </span>



                    <a-row slot="expandedRowRender" slot-scope="record" style="margin: 0">
                        <a-col :span="24">
                            <span class="tb-content-title">关键词:</span>{{ record.productDO.keywords }}
                        </a-col>
                        <a-col :span="24">
                            <span class="tb-content-title">描述:</span>{{ record.productDO.descInfo }}
                        </a-col>
                    </a-row>
                </a-table>
            </a-col>
        </a-row>
    </div>
</template>

<script>


export default {
    name: "Pro",
    data() {
        const columns = [
            {
                title: '产品图片',
                dataIndex: 'productDO.thumb',
                customRender: (record) => {
                    return (
                        <a-popover placement="right">
                            <template slot="content">
                                <img src={record} style="width:500px;"/>
                            </template>
                            <img src={record} style="width:60px;"/>
                        </a-popover>
                    );
                }
            },
            {
                title: '产品名称',
                dataIndex: 'productDO.title',
                sorter: false,
                // width: '20%',
            },
            {
                title: '所属分类',
                dataIndex: 'proCategoryDO.title',
                sorter: false,
                // width: '20%',
            },
            {
                title: '所属网站',
                dataIndex: 'websiteDO.title',
                sorter: false,
                // width: '20%',
            },
            {
                title: '浏览量',
                dataIndex: 'productDO.views',
                sorter: true,
                // width: '20%',
            },
            {
                title: '创建时间',
                dataIndex: 'productDO.createTime',
                sorter: true,
                // width: '20%',
            },
            {
                title: '操作',
                dataIndex: '',
                key: 'x',
                scopedSlots: {
                    customRender: 'action'
                },
            },
        ];
        return {
            data: [],
            pagination: {},
            loading: false,
            columns,
            website:[],
            category:[],
            paramWebsite:[],
            paramCategory:[]
        };
    },
    methods: {
        editContent(uuid) {
            this.$router.push({
                name: "proContent",
                params: {
                    product: uuid
                }
            });
        },
        editInfo(uuid){
            this.$router.push({
                name: "proAdd",
                params: {
                    product: uuid
                }
            });
        },
        handleTableChange(pagination, filters, sorter) {
            const pager = {...this.pagination};
            pager.current = pagination.current;
            this.pagination = pager;
            this.fetch({
                size: pagination.pageSize,
                page: pagination.current,
                website: this.paramWebsite,
                category: this.paramCategory,
                sortField: sorter.field,
                sortOrder: sorter.order,
            });
        },
        fetch: function (params = {}) {
            this.loading = true
            let that = this
            this.$ajax.post(this.$host+"/admin/pro/list",params).then(function (res) {
                that.loading = false
                const result = res.data;
                if (result.code === 200 && result.data.list.length > 0) {
                    const pagination = {...that.pagination};
                    pagination.total = result.data.total;
                    that.data = result.data.list;
                    that.pagination = pagination;
                }
            }).catch(function (err) {
                console.log(err)
            });
        },
        getWebsite() {
            let that = this;
            this.$ajax.get(this.$host+"/admin/website/listAll", {
                params: {}
            }).then(function (res) {
                const result = res.data;
                if (result.code === 200) {
                    that.website = result.data;
                }
            }).catch(function (err) {
                console.log(err)
            });
        },
        getProCategory(websiteList) {
            let that = this;
            this.$ajax.post(this.$host+"/admin/proCategory/listByWebsiteList", websiteList).then(function (res) {
                const result = res.data;
                if (result.code === 200) {
                    that.category = result.data;
                }
            }).catch(function (err) {
                console.log(err)
            });
        },
        handleSelectWebsiteChange(value) {
            this.paramWebsite = value;
            this.getProCategory(value);
            this.fetch({
                size: this.pagination.pageSize,
                page: this.pagination.current,
                website: this.paramWebsite,
                category: this.paramCategory
            });
        },
        handleSelectCategoryChange(value) {
            this.paramCategory = value;
            this.fetch({
                size: this.pagination.pageSize,
                page: this.pagination.current,
                website: this.paramWebsite,
                category: this.paramCategory
            });
        },
        deleteProduct: function (product) {
            let params = new FormData();
            params.set("product",product);
            let that = this;
            this.$ajax.post(this.$host+"/admin/product/delete", params)
                .then(function (res) {
                    const result = res.data;
                    that.$message.info(result.msg);
                    if(result.code===200){
                        that.fetch({
                            size: that.pagination.pageSize,
                            page: that.pagination.current
                        });
                    }
                }).catch(function (err) {
                console.log(err)
            });
        }
    },
    mounted() {
        this.fetch();
        this.getWebsite();
    }
}
</script>

<style scoped>
.tb-content-title {
    font-weight: bolder;
    padding-right: 10px;
    font-size: 15px;
}

.ant-tooltip {
    max-width: 350px !important;
}

.ant-tooltip-inner {
    background-color: white !important;
}
</style>